module.exports = __webpack_public_path__ + "fonts/helvetica-neue-lt-pro-medium.64c38331.woff2";